import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText, FormLabel, InputLabel, Select, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';
import { Row, Col } from "react-bootstrap";

const StyledFormControl = styled(FormControl)({
  '&.shrinkLabel': {
    '& .MuiInputLabel-outlined': {
      transform: 'translate(12px, 12px) scale(1) !important',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(12px, 3px) scale(0.75) !important'
      }
    },
  }
});

export default function SelectInput(props) {

  const { errors, selectOptions, id, variant, helpText, inputColumnSize, hideEmptyOption, ...textFieldProps } = props;
  const columnSize = inputColumnSize || 12;

  const empty = [<option aria-label="None" value="" key={0} />];

  const menuItems = selectOptions && selectOptions.map((option, key) => {
    return <option value={option.value} key={key + 1} disabled={option.disabled}>{option.label}</option>
  });

  var allMenuItems;

  if (selectOptions && hideEmptyOption) {
    allMenuItems = menuItems;
  } else if (selectOptions) {
    allMenuItems = empty.concat(menuItems);
  } else {
    allMenuItems = empty;
  }

  return (
    <Row>
      <Col xs={columnSize}>
        <StyledFormControl
          fullWidth
          variant='outlined'
          error={!!errors}
          className={props.isShrinkLabel ? 'shrinkLabel' : ''}
        >
          {props.labelAbove && <FormLabel component="legend">{props.labelAbove}</FormLabel>}
          <InputLabel htmlFor={id}>{props.label}</InputLabel>
          <Select
            native
            {...textFieldProps}
            inputProps={{
              id: id,
            }}
          >
            {allMenuItems}
          </Select>
          <FormHelperText id={`${id}-helper-text`} aria-describedby={`${id}-helper-text`}>{errors && errors.message}</FormHelperText>
        </StyledFormControl>
      </Col>

      {helpText &&
        <Col xs={2}>
          <div className="d-flex mt-2">
            <Tooltip title={helpText}>
              <InfoIcon color="primary"></InfoIcon>
            </Tooltip>
          </div>
        </Col>
      }
    </Row>
  )
}

SelectInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
  })).isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  variant: PropTypes.string,
  errors: PropTypes.object,
  hideEmptyOption: PropTypes.bool,
  helpText: PropTypes.string
}
